"use client";

import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import styles from "./Form.module.css";

/**
 * Radio — `<input type="radio">` opakowany w `<label>`. Bliźniak `<Checkbox>`.
 *
 * **Wymaga `name`:** radio buttons grupowane są przez wspólny `name`.
 * Konsument odpowiada za rendering grupy:
 *
 *   <Radio name="plan" value="basic">Basic</Radio>
 *   <Radio name="plan" value="pro">Pro</Radio>
 *
 * Dla grupy z label-em całą grupę owinąć w `<fieldset>` + `<legend>` (a11y best
 * practice — przyszły `<RadioGroup>` to wrapper który to robi automatycznie).
 */
export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  function Radio({ label, children, className, ...rest }, ref) {
    const text = children ?? label;
    return (
      <label className={`${styles.choiceLabel}${className ? ` ${className}` : ""}`}>
        <input
          ref={ref}
          type="radio"
          className={styles.choiceInput}
          {...rest}
        />
        {text != null && <span className={styles.choiceText}>{text}</span>}
      </label>
    );
  },
);

export type RadioProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "type" | "children"
> & {
  label?: ReactNode;
  children?: ReactNode;
};
